import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        ptextFn: null
    },
    mutations: {
        ptextFn (state,ptextFn) {
            state.ptextFn = ptextFn
        }
    }
})

export default store;